<template>
    <div class="page">
        <div class="header">
            <img class="logo"
                src="https://yujie-bio.oss-cn-hangzhou.aliyuncs.com/2026/01/08/9cc7f0f4ac4b43b7a42b67eafb53f254.png">
            <img class="companyName"
                src="https://yujie-bio.oss-cn-hangzhou.aliyuncs.com/2026/02/03/7061dc54da1d48c58e335224e9ae0432.png">
            <div style="flex: 1;"></div>
            <div class="navbar">
                <div class="navbarItem" v-for="(item, index) in navbar" :key="index"
                    @click="scrollToAnchor(item.anchorId)">{{
                        item.name }}
                </div>
            </div>
        </div>
        <div class="option">
            <el-breadcrumb separator="/" :replace="true" class="breadcrumb">
                <el-breadcrumb-item :to="{ path: '/' }" :replace="true">首页</el-breadcrumb-item>
                <el-breadcrumb-item>产品中心</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="formBox">
                <div class="selectBox">
                    <el-select class="formItem1" @change="level1SearchChange" v-model="categoryLv1Id"
                        placeholder="请选择一级分类" clearable>
                        <el-option v-for="item in level1ClassList" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select class="formItem2" @change="level2SearchChange" v-model="categoryLv2Id"
                        placeholder="请选择二级分类" clearable>
                        <el-option v-for="item in level2ClassList" :key="item.value" :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <el-input class="formItem3" placeholder="搜索产品..." v-model="name">
                    <el-button slot="append" icon="el-icon-search" @click="serch()"></el-button>
                </el-input>
            </div>
        </div>
        <div class="list" ref="table" :style="{ 'height': height + 'px' }" @scroll="handleScroll">
            <div class="item" v-for="(item, index) in list" :key="index" @click="toDetail(item.id)">
                <div class="imgBox">
                    <img :src="item.coverImages[0]">
                </div>
                <div class="detail">
                    <div class="name">{{ item.name }}</div>
                    <div class="productNo">货号：{{ item.productNo }}</div>
                    <div class="specification">规格：{{ item.skuList ? JSON.parse(item.skuList)[0].value1 : '-' }}</div>
                    <div style="flex: 1;"></div>
                    <div class="priceBtn">
                        <div class="price">¥{{ item.skuList ? JSON.parse(item.skuList)[0].value2 : '-' }}</div>
                        <div class="btn">查看详情</div>
                    </div>
                </div>
            </div>
            <div class="empty" v-if="list.length === 0">暂无更多数据</div>
        </div>
    </div>
</template>
<script>
import { productDetail, productPage, categoryTree } from '../api.js';
export default {
    data() {
        return {
            name: '',
            categoryLv1Id: '',
            categoryLv2Id: '',
            list: [],
            level1ClassList: [],
            level2ClassList: [],
            total: 0,
            size: 20,
            current: 1,
            height: 0,
            loading: false,
            navbar: [
                { name: '首页', anchorId: 'section1' },
                { name: '产品中心', anchorId: 'section2' },
                { name: '代理品牌', anchorId: 'section3' },
                { name: '关于我们', anchorId: 'section4' },
                { name: '联系我们', anchorId: 'section5' }
            ],
        }
    },
    async mounted() {
        this.$nextTick(() => {
            this.getElementHeight()
        })
        await this.getCategoryList()
    },
    methods: {
        scrollToAnchor(anchorId) {
            this.$router.replace({
                path: '/',
                query: {
                    anchorId: anchorId
                }
            })
        },
        handleScroll(event) {
            const container = this.$refs.table;
            if (container.scrollTop + container.clientHeight >= container.scrollHeight - 1) {
                if (this.loading) return; // 防止重复触发
                this.loading = true;
                console.log('已滚动到底部！');
                if (this.list.length == this.total) {
                    this.loading = false;
                    return
                }
                this.current++
                productPage({ current: this.current, size: this.size, categoryLv1Id: this.categoryLv1Id, categoryLv2Id: this.categoryLv2Id, name: this.name }).then(res => {
                    if (res.code == 0) {
                        this.list = [...this.list, ...res.data.list]
                        this.total = res.data.total
                        this.loading = false;
                    }
                })
            }
        },
        toDetail(id) {
            const { href } = this.$router.resolve(
                { path: '/ProductDetail', query: { id: id } }
            );
            window.open(href, '_blank');
        },
        getElementHeight() {
            const container = this.$refs.table;
            if (container) {
                this.height = container.offsetHeight
            }
        },
        async getList() {
            let res = await productPage({ current: this.current, size: this.size, categoryLv1Id: this.categoryLv1Id, categoryLv2Id: this.categoryLv2Id, name: this.name })
            if (res.code == 0) {
                this.list = res.data.list
                this.total = res.data.total
                this.loading = false
            }
        },
        getCategoryList() {
            categoryTree().then(res => {
                if (res.code === 0) {
                    let list = res.data
                    list.forEach(item => {
                        item.label = item.name
                        item.value = item.id
                        item.children.forEach(item2 => {
                            item2.label = item2.name
                            item2.value = item2.id
                        })
                    })
                    this.level1ClassList = list
                    this.categoryLv1Id = this.$route.query.categoryLv1Id || ''
                    if (this.$route.query.categoryLv1Id) {
                        let list2 = this.level1ClassList.filter(item => item.value == this.$route.query.categoryLv1Id)
                        this.level2ClassList = list2[0].children
                    } else {
                        this.level2ClassList = []
                    }
                    this.getList()
                }
            })
        },
        level1SearchChange(val) {
            this.categoryLv2Id = ''
            if (!val) {
                this.level2ClassList = []
                return
            }
            let list = this.level1ClassList.filter(item => item.value == val)
            this.level2ClassList = list[0].children
            this.current = 1
            this.getList()
        },
        serch() {
            this.current = 1
            this.getList()
        },
        level2SearchChange(val) {
            this.current = 1
            this.getList()
        },
    }
}
</script>
<style scoped lang="less">
@media (max-width: 768px) {
    .page {
        padding: 0 0 0 !important;
        box-sizing: border-box !important;

        .header {
            width: 100% !important;
            height: 40px !important;
            padding: 0 10px !important;

            .navbar {
                .navbarItem {
                    font-size: 12px !important;
                }
            }

            .companyName {
                display: none;
            }

            img {
                width: 30% !important;
            }
        }

        .list {
            gap: 10px !important;
            padding: 0 10px !important;

            .item {
                width: calc(50% - 5px) !important;

                .detail {
                    padding: 10px !important;

                    .priceBtn {
                        .price {
                            font-size: 12px !important;
                        }

                        .btn {
                            width: 88px !important;
                            height: 22px !important;
                            line-height: 22px !important;
                            font-size: 12px !important;
                            border-radius: 4px !important;
                        }
                    }

                    .productNo {
                        font-size: 10px !important;
                        margin-bottom: 5px !important;
                    }

                    .specification {
                        font-size: 10px !important;
                        margin-bottom: 5px !important;
                    }

                    .name {
                        font-size: 14px !important;
                        margin-bottom: 5px !important;
                    }
                }


                .imgBox {
                    width: 100%;
                    height: 150px !important;

                    img {
                        height: 150px !important;
                        width: auto;
                        max-width: 100%;
                        object-fit: contain;
                    }
                }
            }
        }

        .formBox {
            display: flex !important;
            flex-direction: column !important;
            flex-wrap: wrap !important;

            // .el-select {
            //     width: 100% !important;
            // }

            .formItem1 {
                width: 50% !important;
            }

            .formItem2 {
                width: 50% !important;
            }

            .formItem3 {
                width: 100% !important;
            }
        }

        .bottom {
            overflow: hidden !important;
            overflow-x: scroll !important;

            .el-pagination {
                width: 100% !important;
            }
        }

        .option {
            padding: 0 10px 10px !important;
            box-sizing: border-box !important;
        }

        .breadcrumb {
            margin: 5px 0 !important;
        }
    }
}
</style>
<style scoped lang="less">
.page {
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
    word-break: break-all;
    padding: 0 0 0;
    background-color: #f9fafb;
    display: flex;
    flex-direction: column;

    .header {
        padding: 0 150px;
        background-color: #fff;
        width: 100%;
        height: 80px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        .companyName {
            margin-left: 10px;
            width: 250px;
        }

        .logo {
            width: 160px;
        }


        .navbar {
            display: flex;

            .navbarItem:hover {
                color: #2d62ff;
            }

            .navbarItem {
                margin-left: 32px;
                font-size: 17px;
                color: #1f2939;
                cursor: pointer;
                font-weight: 500;
            }
        }
    }

    .list::-webkit-scrollbar {
        display: none;
    }

    .list {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        overflow: hidden;
        overflow-y: scroll;
        align-content: flex-start;
        position: relative;
        gap: 25px;
        padding: 0 150px;
        box-sizing: border-box;

        .empty {
            position: absolute;
            top: 50%;
            left: 50%;
            color: #999;
            transform: translate(-50% -50%);
        }

        .item:hover {
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        }

        .item {
            cursor: pointer;
            transition: all 0.3s;
            width: calc(17% - 27px);
            border: 1px solid #e5e7eb;
            border-radius: 8px;
            overflow: hidden;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;

            .detail {
                flex: 1;
                padding: 16px;
                box-sizing: border-box;
                display: flex;
                flex-direction: column;

                .priceBtn {
                    display: flex;
                    align-items: center;

                    .price {
                        flex: 1;
                        font-size: 18px;
                        color: #3b66ff;
                        font-weight: 600;
                    }

                    .btn {
                        width: 88px;
                        height: 36px;
                        text-align: center;
                        line-height: 36px;
                        background-color: #3b66ff;
                        color: #fff;
                        font-size: 14px;
                        font-weight: 500;
                        border-radius: 4px;
                    }
                }

                .productNo {
                    font-size: 16px;
                    color: #5a5a5a;
                    margin-bottom: 5px;
                    font-weight: 600;
                }

                .specification {
                    font-size: 16px;
                    color: #5a5a5a;
                    font-weight: 600;
                    margin-bottom: 10px;
                }

                .name {
                    font-size: 16px;
                    color: #000;
                    font-weight: 600;
                    margin-bottom: 5px;
                    box-sizing: border-box;
                }
            }

            .imgBox {
                width: 100%;
                display: flex;
                justify-content: center;
                height: 200px;
                padding: 10px 10px 0;
                box-sizing: border-box;

                img {
                    height: 100%;
                    width: auto;
                    max-width: 100%;
                    object-fit: contain;
                }
            }
        }

        .item:nth-child(5n) {
            margin-right: 0;
        }
    }

    .option {
        width: 100%;
        border-radius: 12px;
        padding: 24px 150px;
        box-sizing: border-box;

        .breadcrumb {
            margin: 0 0 24px;
        }

        .formBox {
            display: flex;
            align-items: center;
            gap: 24px;

            .selectBox {
                flex: 2;
                display: flex;
                gap: 24px;

                .formItem1 {
                    flex: 1;
                }

                .formItem2 {
                    flex: 1;
                }
            }

            .formItem3 {
                flex: 1;
            }
        }
    }

    .bottom {
        margin-top: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>